export class DeckEntry {
    public CardID: number;
    public EntryCount: number;
    public isCommander: boolean;
    public isProxy: boolean;
}
